import { useEffect } from 'react';
import { useFormik } from 'formik';
import {
    PqrDataSfc,
    PqrReconsideration,
    PqrStatusSmart,
} from '../../../../../../shared/types/modules/pqr';
import { useGetNameOrValue } from '../../../../../../shared/utils/useGetNameOrValue';
import dayjs from 'dayjs';
import { ISelect } from '../../../../../../shared/types/shared';

export const usePqrDataSfc = (
    status?: ISelect,
    dataSfc?: PqrDataSfc,
    hasReconsideration?: boolean,
    gender?: string,
    isLGBTIQ?: boolean,
    half?: string,
    dataReconsideration?: PqrReconsideration
) => {
    const formik = useFormik({
        initialValues: {
            channelPresentsFailure: '',
            isGuardianship: false,
            guardianship: '',
            controlEntity: '',
            dcfScaling: false,
            hasReconsideration: false,
            desistd: '',
            hasExpressComplaint: false,
            receptionInstance: '',
            receptionPoint: '',
            admission: '',
            status: '',
            acceptance: '',
            rectification: '',
            isExtension: false,
            finalResponseAttached: false,
            isVirtualProduct: false,
            marking: '',
            closingDateDCF: null as dayjs.Dayjs | null,
            customerFilingDate: null as dayjs.Dayjs | null,
            updateStatusPQRDate: null as dayjs.Dayjs | null,
            answerSFCDate: null as dayjs.Dayjs | null,
            gender: '',
            isLGBTIQ: false,
            fraudType: '',
            fraudMode: '',
            claimedAmount: '0',
            approvedAmount: '0',
            replica: '',
            pqrReplica: '',
            observationsReplica: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik.setValues({
            channelPresentsFailure: useGetNameOrValue(
                dataSfc?.channelPresentsFailure || ''
            ),
            isGuardianship: dataSfc?.isGuardianship || false,
            guardianship: dataSfc?.guardianship || '',
            controlEntity: useGetNameOrValue(dataSfc?.controlEntity || ''),
            dcfScaling: dataSfc?.dcfScaling || false,
            hasReconsideration: hasReconsideration || false,
            desistd: useGetNameOrValue(dataSfc?.desistd || ''),
            hasExpressComplaint: dataSfc?.hasExpressComplaint || false,
            receptionInstance: useGetNameOrValue(
                dataSfc?.receptionInstance || ''
            ),
            receptionPoint: useGetNameOrValue(dataSfc?.receptionPoint || ''),
            admission: useGetNameOrValue(dataSfc?.admission || ''),
            status: status?.valueSmart
                ? PqrStatusSmart[
                      `KEY_${status?.valueSmart}` as keyof typeof PqrStatusSmart
                ]
                : '',
            acceptance: useGetNameOrValue(dataSfc?.acceptance || ''),
            rectification: useGetNameOrValue(dataSfc?.rectification || ''),
            isExtension: dataSfc?.isExtension || false,
            finalResponseAttached: dataSfc?.finalResponseAttached || false,
            isVirtualProduct: dataSfc?.isVirtualProduct || false,
            marking: useGetNameOrValue(dataSfc?.marking || ''),
            closingDateDCF: dayjs(dataSfc?.closingDateDCF) || null,
            customerFilingDate: dayjs(dataSfc?.customerFilingDate) || null,
            updateStatusPQRDate: dayjs(dataSfc?.updateStatusPQRDate) || null,
            answerSFCDate: dayjs(dataSfc?.answerSFCDate) || null,
            gender: gender || '',
            isLGBTIQ: Boolean(isLGBTIQ),
            fraudType: useGetNameOrValue(dataSfc?.fraudType || ''),
            fraudMode: useGetNameOrValue(dataSfc?.fraudMode || ''),
            claimedAmount: dataSfc?.claimedAmount || '',
            approvedAmount: dataSfc?.approvedAmount || '',
            replica: useGetNameOrValue(dataReconsideration?.replica || ''),
            pqrReplica: dataReconsideration?.pqrReplica || '',
            observationsReplica: dataReconsideration?.observations || '',
        });
    }, [dataSfc, status]);

    return {
        formik,
        isDCF: half === 'DCF',
    };
};
